import { ApiService } from "./02_utils/apiService";
import { Logger } from "./02_utils/logger";
import { Utils } from "./02_utils/utils";
import { Countup } from "./03_elements/countup/countup";
import { Link } from "./03_elements/link/link";
import { Panel } from "./03_elements/panel/panel";
import { Select } from "./03_elements/select/select";
import { Header } from "./04_layout/header/header";
import { Hero } from "./04_layout/hero/hero";
import { Navigation } from "./04_layout/navigation/navigation";
import { ToTop } from "./04_layout/toTop/toTop";
import { ChickenSwitch } from "./05_components/chicken-switch/chickenSwitch";
import { MediaText } from "./05_components/media-text/mediaText";
import { Tiles } from "./05_components/tiles/tiles";



export class Main {
    constructor() {
      const logger = new Logger();
      const utils = new Utils(logger);
      const apiService = new ApiService(logger);

      // utils
      utils.clickFlyoutPanelBackdrop();

      // const base = new Base(logger, utils);


      new Header(logger, utils);
      new Link(logger, utils);

      // Navigation
      const navigations: NodeListOf<HTMLElement> = document.querySelectorAll('header');
      navigations?.forEach(navigation => {
        new Navigation(navigation, logger, utils);
      });

      new Select(logger, utils);
      new Panel(logger, utils);
      new ChickenSwitch(logger, utils);
      new MediaText(logger, utils);
      new Tiles(logger, utils);
      new ToTop(utils);
      new Hero(logger, utils);
      new Countup(logger, utils);
    }
}
